/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const ClientMessage = props => {
  const clientMessageClasses = cx('Client-message', props.className, {
    'Client-message--separate': props.separate
  });

  return (
    <div className={clientMessageClasses}>
      <div
        className={cx('Client-message__bubble', {
          'Client-message__large': props.large
        })}>
        {props.children}
      </div>
    </div>
  );
};

ClientMessage.propDefaults = {
  separate: false
};

ClientMessage.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  large: PropTypes.bool, // set to true if ClientMessage is large and would touch edge of panel
  separate: PropTypes.bool // set to true if the ClientMessage is used separately and is not part of chat-flow preview
};

export default ClientMessage;
